<app-profile-photo
  [user]="user"
  width="48"
  fontSize="18"
  [isClickEnabled]="false"
></app-profile-photo>
<div *ngIf="user" class="details">
  <div class="name">{{ user.name }}</div>
  <div class="info">
    <div class="suspended-tag" *ngIf="user.revoked?.type === REVOKED_TYPES.SUSPENDED">
      <i class="material-icons-outlined">warning_amber</i>
      {{ 'Suspended' | translate }}
    </div>
    <div *ngIf="user.isApiManaged" class="isApiManaged-chip">
      <app-pill
        [text]="'Managed via API' | translate"
        [type]="'user'"
        [color]="'#ffffff'"
        [svgIcon]="'api'"
        [showXButton]="false"
      >
      </app-pill>
    </div>
    <span *ngIf="!user.isApiManaged" class="profile-email">{{ user.email }}</span>
  </div>
</div>
